import { action } from 'typesafe-actions';

import { TravelsApprovalResponse } from 'models/travelApproved';

export const TRAVELS_ADMIN_REQUEST = 'TRAVELS_ADMIN_REQUEST';
export const FETCH_ALL_TRAVELS_ADMIN_SUCCESSFUL = 'FETCH_ALL_TRAVELS_ADMIN_SUCCESSFUL';
export const FETCH_ALL_TRAVELS_ADMIN_FAILURE = 'FETCH_ALL_TRAVELS_ADMIN_FAILURE';
export const SET_TRAVEL_ITINERARY_ID = 'SET_TRAVELITINERARYID';

export const setTravelItineraryId = (itineraryId: string) => action(SET_TRAVEL_ITINERARY_ID, itineraryId);

export const allTravelsAdminRequest = () => action(TRAVELS_ADMIN_REQUEST);

export const fetchAllTravelAdmin = (travel: TravelsApprovalResponse) =>
  action(FETCH_ALL_TRAVELS_ADMIN_SUCCESSFUL, travel);

export const fetchAllTravelAdminError = (error: string) => action(FETCH_ALL_TRAVELS_ADMIN_FAILURE, error);
